<template>
  <div class="scrollTitle">
    <div @mouseenter="stopAnim" @mouseleave="revertAnim" class="wrapper">
      <ul :style="getTransform" class="titlelist">
        <li @click.stop="clickItem(course)" v-for="course in courseList">
          <div><i class="iconfont icon-ke"></i>{{course.time}}</div>
          <div>{{course.kcmc}}</div>
          <div>{{course.skdd}}</div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  export default {
    name: "scrollTitle",
    data() {
      return {
        currentShowIdx: 0,
        timer: null
      }
    },
    props: {

      /***
       * cousrseList:传入的主数据[Array]
       * during:滚动时间间隔[Number]
       */

      courseList: {
        type: Array,
        default() {
          return [
            {
              "jsh": "69教室123",
              "kcm": "医院网络技术与管理",
              "llsynr": "计算机网络的基本概念",
              "skbj": "生1601",
              "skjc": "3",
              "skrq": "2019-03-04",
              "xs": "2"
            },
            {
              "jsh": "计算机1",
              "kcm": "毛概123",
              "llsynr": "计算机网络协议与体系架构",
              "skbj": "生16021",
              "skjc": "5",
              "skrq": "2019-03-04",
              "xs": "2"
            },
            {
              "jsh": "计算机2",
              "kcm": "大学英语1234",
              "llsynr": "局域网组建",
              "skbj": "生16021",
              "skjc": "7",
              "skrq": "2019-03-04",
              "xs": "1"
            },
            {
              "jsh": "69教室",
              "kcm": "医院网络技术与管理",
              "llsynr": "计算机网络的基本概念",
              "skbj": "生1601",
              "skjc": "1",
              "skrq": "2019-03-04",
              "xs": "2"
            }
          ];
        }
      },
      during: {
        type: Number,
        default: 3000,
      }
    },
    methods: {

      createAnim() {
        this.timer = setInterval(() => {
          if (this.currentShowIdx >= this.courseList.length - 1) {
            this.currentShowIdx = 0;
            return;
          }
          this.currentShowIdx++;
        }, this.during)
      },
      clearAnim() {
        clearInterval(this.timer)
      },
      stopAnim() {
        this.clearAnim();
      },
      revertAnim() {
        this.createAnim()
      },
      clickItem(item) {
        this.$emit("clickItem", item)
      }

    },
    watch: {
      courseList(newVal) {
        this.currentShowIdx = 0
      }
    },
    computed: {
      getTransform() {
        return `transform:translateY(${-this.currentShowIdx * 30}px)`
      }
    },
    mounted() {
      this.createAnim()
    },
    components: {}
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
  .scrollTitle
    /*margin-top 10px*/
    margin-top 10px
    margin-bottom -5px

    .wrapper
      /*border 1px solid #00f*/
      height 30px
      overflow hidden

      .titlelist
        transition 300ms

        li
          line-height 30px
          height 30px
          transition 300ms
          cursor pointer
          white-space nowrap

          &:hover div
            color #666666

          div:first-of-type
            text-align left
            width 60px
            min-width 60
            padding-right 0
            padding-left 2px

          div
            display inline-block
            padding 0 10px
            max-width 200px
            /*max-width 80px*/
            /*min-width 70px*/
            overflow hidden
            white-space nowrap
            text-overflow ellipsis
            text-align left
            font-size 14px
            color #999999
            line-height 30px
            height 30px
            flex 1
            transition 300ms

            i.iconfont
              color #2b5c95
              font-size 14px
              margin-right 5px
              vertical-align middle

</style>


// WEBPACK FOOTER //
// src/components/course/courseScrollList.vue